export default "__VITE_ASSET__f6034bd8__"